"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecommendationContext = void 0;
const react_1 = require("react");
exports.RecommendationContext = (0, react_1.createContext)({
    productGroupRecommendation: false,
    isRec: false,
});
//# sourceMappingURL=RecommendationContext.js.map